import { Serializable } from './ISerializeable';

export class TAGConfig implements Serializable {
  enableSongRequests: boolean = false;
  songRequestTimeouts: number = 5 * 60;
  defaultGallery: string = '';
  enableSchulradio: boolean = false;
  allowGroupsForBookIn: boolean = false;
  allowReturnItemsNotInTransaction: boolean = false;
  allowItemRebooking: boolean = false;

  labelTemplate: string = '';
  groupLabelTemplate: string = '';

  constructor(info: any = {}) {
    this.deserialize(info);
  }

  serialize(): any {
    var obj: any = {};

    obj.enableSongRequests = this.enableSongRequests;
    obj.songRequestTimeouts = this.songRequestTimeouts;
    obj.defaultGallery = this.defaultGallery;
    obj.enableSchulradio = this.enableSchulradio;
    obj.allowGroupsForBookIn = this.allowGroupsForBookIn;
    obj.allowReturnItemsNotInTransaction = this.allowReturnItemsNotInTransaction;
    obj.allowItemRebooking = this.allowItemRebooking;

    obj.labelTemplate = this.labelTemplate;
    obj.groupLabelTemplate = this.groupLabelTemplate;

    return obj;
  }

  deserialize(data: any) {
    if (data.enableSongRequests != null) this.enableSongRequests = data.enableSongRequests;
    if (data.songRequestTimeouts != null) this.songRequestTimeouts = data.songRequestTimeouts;
    if (data.defaultGallery != null) this.defaultGallery = data.defaultGallery;
    if (data.enableSchulradio != null) this.enableSchulradio = data.enableSchulradio;
    if (data.allowGroupsForBookIn != null) this.allowGroupsForBookIn = data.allowGroupsForBookIn;
    if (data.allowReturnItemsNotInTransaction != null) this.allowReturnItemsNotInTransaction = data.allowReturnItemsNotInTransaction;
    if (data.allowItemRebooking != null) this.allowItemRebooking = data.allowItemRebooking;

    if (data.labelTemplate != null) this.labelTemplate = data.labelTemplate;
    if (data.groupLabelTemplate != null) this.groupLabelTemplate = data.groupLabelTemplate;
  }
}
